import axios from 'axios';
import { getAuthHeaders } from './userController';

const TURNO_URL = 'https://yokomo.api.ikeytechnologies.com/turnos/';

// Obtener todos los turnos semanales
export const fetchTurnosSemanales = async () => {
  try {
    const response = await axios.get(TURNO_URL, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener los turnos semanales:', error);
    throw error;
  }
};

// Obtener un turno semanal específico
export const fetchTurnoSemanal = async (id) => {
  try {
    const response = await axios.get(`${TURNO_URL}${id}/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener el turno semanal:', error);
    throw error;
  }
};

export const fetchTurnoPorEmpleado = async (empleadoId) => {
  try {
    const response = await axios.post(
      TURNO_URL+"empleados/",
      { empleado_id: empleadoId },
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error al obtener el turno del empleado:', error);
    throw error;
  }
};

// Crear un nuevo turno semanal
export const createTurnoSemanal = async (data) => {
  try {
    const response = await axios.post(TURNO_URL, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al crear el turno semanal:', error);
    throw error;
  }
};

// Actualizar un turno semanal
export const updateTurnoSemanal = async (id, data) => {
  try {
    const response = await axios.put(`${TURNO_URL}${id}/`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el turno semanal:', error);
    throw error;
  }
};

// Eliminar un turno semanal
export const deleteTurnoSemanal = async (id) => {
  try {
    const response = await axios.delete(`${TURNO_URL}${id}/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el turno semanal:', error);
    throw error;
  }
};
